import type { AppDispatch } from "store";
import { addNewLead, type AddNewLeadPayload } from "services/leadService";
import {
  setLeadLoading,
  setLeadSuccess,
  setLeadError,
} from "./reducer";

export const addNewLeadThunk =
  (payload: AddNewLeadPayload) => async (dispatch: AppDispatch) => {
    dispatch(setLeadLoading(true));
    dispatch(setLeadError(null));
    try {
      console.log("=== ADD NEW LEAD THUNK ===");
      console.log("Dispatching with payload:", JSON.stringify(payload, null, 2));
      console.log("======================================");

      const response = await addNewLead(payload);

      console.log("=== ADD NEW LEAD API RESPONSE ===");
      console.log("Response:", JSON.stringify(response, null, 2));
      console.log("======================================");

      if (response.success) {
        dispatch(
          setLeadSuccess({
            message: response.message || "Lead has been saved successfully",
            leadId: response.data,
          })
        );
        return { success: true, data: response.data, message: response.message };
      } else {
        const errorMessage = response.message || "Failed to save lead";
        dispatch(setLeadError(errorMessage));
        return { success: false, message: errorMessage };
      }
    } catch (error: any) {
      console.log("=== ADD NEW LEAD THUNK ERROR ===");
      console.log("Error:", error);
      console.log("Error Response Data:", error?.response?.data);
      console.log("======================================");

      // Extract exact message from API error response
      let errorMessage = "Failed to save lead. Please try again.";
      
      // Check if error.response.data exists and has a message
      if (error?.response?.data) {
        // If it's an object with a message property
        if (typeof error.response.data === 'object' && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        // If it's a string directly
        else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        }
      }
      // If error itself has a message (from service layer)
      else if (error?.message) {
        errorMessage = error.message;
      }
      
      dispatch(setLeadError(errorMessage));
      return { success: false, message: errorMessage };
    } finally {
      dispatch(setLeadLoading(false));
    }
  };

